export const PROFILE_VERTICALS = ['dating', 'linkedin'];
/**
 * The product is moving to two user-facing verticals while the rest of the
 * application still has legacy app contexts and rating contexts. Keep the
 * compatibility mapping in one place so web, iOS, and workers stay aligned.
 */
export const PROFILE_VERTICAL_CONFIGS = {
    dating: {
        id: 'dating',
        label: 'Dating',
        shortLabel: 'Dating',
        emoji: '💕',
        description: 'Find your best dating photos and improve the rest of your profile.',
        appContext: 'dating',
        ratingContext: 'dating',
        landingPath: '/dating',
        heroTitle: 'Find your best Hinge, Tinder, or Bumble photo.',
        heroSubtitle: 'Upload your profile photos, get them ranked, and learn how to improve the weaker ones.',
        ctaLabel: 'Upload dating photos',
        focusAreas: [
            'Lead photo selection',
            'Lineup order guidance',
            'Prompt and bio tune-up',
            'Match and reply tracking',
        ],
        workspaceTagline: 'Lead photo, lineup, matches',
    },
    linkedin: {
        id: 'linkedin',
        label: 'LinkedIn',
        shortLabel: 'LinkedIn',
        emoji: '💼',
        description: 'Choose the headshot that makes the strongest professional impression.',
        appContext: 'professional',
        ratingContext: 'business',
        landingPath: '/linkedin',
        heroTitle: 'Choose the headshot that makes the strongest professional impression.',
        heroSubtitle: 'Compare your options, get clear feedback, and pick the recruiter-ready winner.',
        ctaLabel: 'Upload LinkedIn photos',
        focusAreas: [
            'Headshot selection',
            'Headline tune-up',
            'About section coaching',
            'Banner guidance',
            'Recruiter and view tracking',
        ],
        workspaceTagline: 'Headshot, headline, recruiter messages',
    },
};
export function getProfileVertical(id) {
    if (!id)
        return undefined;
    return PROFILE_VERTICAL_CONFIGS[id];
}
export function isProfileVertical(value) {
    return value === 'dating' || value === 'linkedin';
}
export function normalizeProfileVertical(value) {
    if (value === 'linkedin' || value === 'professional' || value === 'business') {
        return 'linkedin';
    }
    return 'dating';
}
export function getAppContextForVertical(vertical) {
    return PROFILE_VERTICAL_CONFIGS[vertical].appContext;
}
export function getRatingContextForVertical(vertical) {
    return PROFILE_VERTICAL_CONFIGS[vertical].ratingContext;
}
export function getProfileVerticalFromAppContext(appContext) {
    if (!appContext)
        return undefined;
    if (appContext === 'dating')
        return 'dating';
    if (appContext === 'professional')
        return 'linkedin';
    return undefined;
}
